import { ContenidoStatus } from './../../../../../common/contenido';
import { Action } from '@ngrx/store';
import { Contenido } from 'src/common/contenido';
import { PageQuery } from 'src/common/page-query';

export enum ContenidoActionTypes {
	ContenidoPageRequested = '[Contenido Component] Contenido Page Requested',
	ContenidoPageLoaded = '[Contenido API] Contenido Page Loaded',
	ContenidoPageCancelled = '[Contenido API] Contenido Page Cancelled',
	ContenidoPageRight = '[Contenido API] Contenido Page Right'
}

export class ContenidoPageRequested implements Action {
	readonly type: string = ContenidoActionTypes.ContenidoPageRequested;
	constructor( public payload: { shouldLoadMoreContent: boolean } ) {
	}
}

export class ContenidoPageLoaded implements Action {
	readonly type: string = ContenidoActionTypes.ContenidoPageLoaded;
	constructor( public payload: { cleared: boolean, nextPageNum: number, status: ContenidoStatus, contenido: Contenido[] } ) {
	}
}

export class ContenidoPageCancelled implements Action {
	readonly type: string = ContenidoActionTypes.ContenidoPageCancelled;
	constructor( public payload: { status: ContenidoStatus } )  {
	}
}

export class ContenidoPageRight implements Action {
	readonly type: string = ContenidoActionTypes.ContenidoPageRight;
	constructor()  {
	}
}

export type ContenidoActions = ContenidoPageRequested | ContenidoPageLoaded | ContenidoPageCancelled | ContenidoPageRight;
